import { Box, Typography } from "@mui/material";

function parts(at: Date, timeZone?: string | null) {
  const zone = timeZone ? { timeZone } : {};
  try {
    return {
      weekday: new Intl.DateTimeFormat(undefined, { ...zone, weekday: "short" }).format(at),
      day: new Intl.DateTimeFormat(undefined, { ...zone, day: "numeric" }).format(at),
    };
  } catch {
    // An unknown zone keeps the real instant in UTC rather than failing the row.
    return parts(at, "UTC");
  }
}

/** Leading "SAT / 31" tile for dense dated rows (Up next, events, bookings). */
export function DateBadge({
  at,
  timeZone,
  tile = false,
}: {
  at: string;
  timeZone?: string | null;
  /** The approved square date tile (8px corners); default keeps the existing badge. */
  tile?: boolean;
}) {
  const date = new Date(at);
  if (Number.isNaN(date.getTime())) return null;
  const { weekday, day } = parts(date, timeZone);
  return (
    <Box
      aria-hidden
      sx={{ width: 44, flexShrink: 0, textAlign: "center", bgcolor: "action.hover", borderRadius: tile ? "8px" : 2, py: 0.5, lineHeight: 1.1 }}
    >
      <Typography sx={{ fontSize: "0.625rem", fontWeight: 800, color: "primary.main", textTransform: "uppercase" }}>
        {weekday}
      </Typography>
      <Typography sx={{ fontSize: "1.0625rem", fontWeight: 700 }}>{day}</Typography>
    </Box>
  );
}
